<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            机构列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row style="float: left;">
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">

                        <el-table-column prop="name" label="名称" width="200" fixed></el-table-column>

                        <el-table-column prop="tel" label="固话" width="150"></el-table-column>
                        <el-table-column prop="contacts" label="联系人" width="100"></el-table-column>
                        <el-table-column prop="isChain" label="连锁" width="80">
                            <template slot-scope="scope">
                                <div v-if="scope.row.isChain == '0'">否</div>
                                <div v-if="scope.row.isChain == '1'">是</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="chainType" label="机构类别" width="80">
                            <template slot-scope="scope">
                                <div v-if="scope.row.chainType == 'parent'">总机构</div>
                                <div v-if="scope.row.chainType == 'middle'">中间机构</div>
                                <div v-if="scope.row.chainType == 'son'">分机构</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="listSonInstitutionRelDTO" label="分机构">
                            <template slot-scope="scope">
                                 <span v-for="item in scope.row.listSonInstitutionRelDTO" v-bind:key="item.institutionRelCode">
                                    <div>{{item.sonInstitutionName}}</div>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="地址"></el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status==0">默认</span>
                                <span v-if="scope.row.status==1">正常</span>
                                <span v-if="scope.row.status==2">禁用</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="180">
                            <template slot-scope="scope">
                                <p>{{scope.row.createTime | timefilters }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="staffDTO" label="机构管理员" width="180">
                            <template slot-scope="scope">
                                <span v-if="scope.row.staffDTO != null">{{scope.row.staffDTO.realName }}</span>
                                <span v-if="scope.row.staffDTO == null" style="color: red;">未设置</span>
                            </template>
                        </el-table-column>



                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>

                                <el-button v-if="scope.row.isChain == 1 && scope.row.chainType != 'son'" type="text" size="small"
                                           @click="handleEditSon(scope.$index, scope.row)">编辑分机构</el-button>

                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="pageSize"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <EditSon ref="myEditSon" v-show="showModalEditSon" v-on:closeEditSon="closeEditSon" v-on:getList="getList"></EditSon>

    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import EditSon from "./EditSon";

    export default {
        name: "Page",
        components:{Add,Edit,EditSon},

        //注册局部过滤器
        filters: {
            timefilters(val) {
                return timefilters(val)
            }
        },

        data(){
            return{
                loading:true,

                showModalAdd:false,
                showModalEdit:false,
                showModalEditSon:false,

                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

            }
        },

        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{


            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },


            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },


            handleEditSon(index,row){
                this.$refs.myEditSon.init(row);
                this.showModalEditSon = !this.showModalEditSon;
            },
            closeEditSon:function(){
                this.showModalEditSon = !this.showModalEditSon;
            },


            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Institution/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfoInstitutionDTO.list;
                        this.totalItems = response.data.data.pageInfoInstitutionDTO.total;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style lang="scss" scoped>

</style>